module.exports = __webpack_public_path__ + "static/types-5de91ece90d6c403796124ade3165901.png";